export const VIEW_PERMISSION = {
  EDIT: 'Edit',
  READ: 'Read',
};

export const RECORD_CATEGORY_KEYS = {
  BOOKINGS: 'Bookings',
  CAD_INCIDENTS: 'CadIncidents',
  CITATIONS: 'Citations',
  RMS_INCIDENTS: 'RmsIncidents',
  WARRANTS: 'Warrants',
};

export const CATEGORIES = [
  RECORD_CATEGORY_KEYS.BOOKINGS,
  RECORD_CATEGORY_KEYS.CAD_INCIDENTS,
  RECORD_CATEGORY_KEYS.CITATIONS,
  RECORD_CATEGORY_KEYS.RMS_INCIDENTS,
  RECORD_CATEGORY_KEYS.WARRANTS,
];

export const CATEGORY_LABELS = {
  [RECORD_CATEGORY_KEYS.BOOKINGS]: 'Bookings',
  [RECORD_CATEGORY_KEYS.CAD_INCIDENTS]: 'Cad Incidents',
  [RECORD_CATEGORY_KEYS.CITATIONS]: 'Citations',
  [RECORD_CATEGORY_KEYS.RMS_INCIDENTS]: 'Rms Incidents',
  [RECORD_CATEGORY_KEYS.WARRANTS]: 'Warrants',
};
